(() => {
  const dialog = document.querySelector('[data-wy-cookie-dialog]');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const status = dialog.querySelector('[data-wy-cookie-status]');
  const purposes = ['preferences', 'analytics', 'marketing'];
  let opener, busy = false, ready;
  const controls = () => [...form.querySelectorAll('button,input:not([disabled])')];
  function api() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!ready) ready = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('timeout')), 10000);
      if (!window.Shopify?.loadFeatures) { clearTimeout(timer); reject(new Error('unavailable')); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        clearTimeout(timer);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { ready = undefined; throw error; });
    return ready;
  }
  async function open(button) {
    if (busy) return;
    opener = button;
    status.textContent = dialog.dataset.loading;
    if (!dialog.open) dialog.showModal();
    const nodes = controls();
    nodes.forEach(n => n.disabled = true);
    try {
      const privacy = await api();
      const current = privacy.currentVisitorConsent();
      purposes.forEach(key => form.elements[key].checked = current[key] === 'yes');
      status.textContent = '';
    } catch { status.textContent = dialog.dataset.error; }
    finally { nodes.forEach(n => n.disabled = false); }
  }
  async function save(rejectAll = false) {
    if (busy) return;
    busy = true;
    const nodes = controls();
    nodes.forEach(n => n.disabled = true);
    status.textContent = dialog.dataset.loading;
    try {
      const privacy = await api();
      const consent = Object.fromEntries(purposes.map(key => [key, rejectAll ? false : form.elements[key].checked]));
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('timeout')), 10000);
        privacy.setTrackingConsent(consent, () => { clearTimeout(timer); resolve(); });
      });
      const saved = privacy.currentVisitorConsent();
      if (purposes.some(key => saved[key] !== (consent[key] ? 'yes' : 'no'))) throw new Error('not saved');
      purposes.forEach(key => form.elements[key].checked = consent[key]);
      status.textContent = dialog.dataset.saved;
    } catch { status.textContent = dialog.dataset.error; }
    finally { busy = false; nodes.forEach(n => n.disabled = false); }
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-cookie-preferences]');
    if (button) { e.preventDefault(); open(button); }
  });
  dialog.querySelector('[data-wy-cookie-close]').addEventListener('click', () => { if (!busy) dialog.close(); });
  dialog.addEventListener('cancel', e => { if (busy) e.preventDefault(); });
  dialog.addEventListener('close', () => opener?.focus());
  form.addEventListener('submit', e => { e.preventDefault(); save(); });
  dialog.querySelector('[data-wy-cookie-reject]').addEventListener('click', () => save(true));
})();
